import { default as MuiTableSortLabel } from '@mui/material/TableSortLabel';

/**
 * TableSortLabel adds a clickable sort indicator to a table column header.
 *
 * Demos:
 *
 * - [Table — Sortable Header](https://unify.workiva.org/components/table?tab=code#sortable-header)
 *
 * API:
 *
 * - [TableSortLabel API](https://unify.workiva.org/components/table?tab=props#tablesortlabel)
 */
export const TableSortLabel = MuiTableSortLabel;
export {
  type TableSortLabelProps,
  tableSortLabelClasses,
} from '@mui/material/TableSortLabel';
